import React, { useEffect } from "react";
import { footer_web } from "../../../locales/en";
import { COPYRIGHT } from "../../../utils/constants/appConstants";
import { useSelector } from "react-redux";
import "./footer.scss";
const Footer = () => {
  const { isMenuActive } = useSelector((state) => state.dashboardTable);
  useEffect(() => {
    const getYearElement = document.getElementById("getYear");
    if (getYearElement) {
      const currentYear = new Date().getFullYear();
      getYearElement.textContent = currentYear;
    }
  }, []);
  return (
    <div className="container-fluid m-0">
      <div className="row me-0 ms-0 mt-5">
        <div className="col-12">
          <div
            className={`dashboard-footer ${isMenuActive ? "active-sidebar" : ""}`}
          >
            <p>
              {footer_web?.footerBottom?.copyright} {COPYRIGHT}
              <span id="getYear" /> {footer_web?.footerBottom?.fundTap}
              {footer_web?.footerBottom?.allRightsReserved}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
